import { html, LitElement } from 'lit'
import { customElement, property, queryAssignedNodes, state } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import style from './style/zaptic-dropdown-style'
import normalize from './style/normalize-style'

@customElement('zaptic-dropdown')
export class Dropdown extends LitElement {
    static styles = [style, normalize]

    @property()
    title: string
    @state()
    _isOpen = false
    @state()
    _hasTriggerElement = false

    @queryAssignedNodes({ slot: 'trigger', flatten: true })
    _triggerNodes!: Node[]

    handleTriggerElementClicked() {
        this._isOpen = !this._isOpen
    }

    handleSlotChanged() {
        this._hasTriggerElement = !!this._triggerNodes[0]
    }

    render() {
        return html`
            <slot
                @slotchange=${this.handleSlotChanged}
                @click=${this.handleTriggerElementClicked}
                name="trigger"
            ></slot>
            ${!this._triggerNodes[0] || this._isOpen
                ? html`<div
                      part="container"
                      class="${classMap({ 'dropdown-container': true, 'has-trigger': this._hasTriggerElement })}"
                  >
                      <div class="title">${this.title}</div>
                      <slot></slot>
                  </div>`
                : null}
        `
    }
}
